import { render, staticRenderFns } from "./NormHolderzy.vue?vue&type=template&id=12b438ea&scoped=true&"
import script from "./NormHolderzy.vue?vue&type=script&lang=js&"
export * from "./NormHolderzy.vue?vue&type=script&lang=js&"
import style0 from "./NormHolderzy.vue?vue&type=style&index=0&id=12b438ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b438ea",
  null
  
)

export default component.exports